import { NameSpace } from './locales.types';

export const DEFAULT_NAME_SPACE: NameSpace = 'common';
